var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "steps-template" }, [
    _c(
      "div",
      { staticClass: "steps" },
      _vm._l(_vm.stepItems, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "step is-center",
            style: { flexBasis: index == 1 ? "60%" : "20%" }
          },
          [
            _c(
              "div",
              {
                staticClass: "step__head",
                class: { "is-finish": !(index > _vm.activeStep) }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "step__line",
                    class: { "last-step": index == _vm.stepItems.length - 1 },
                    style: {
                      right: index == 0 ? "-150%" : index == 1 ? "-17%" : "-50%"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "step__line-inner",
                      class: [index < _vm.activeStep ? "is-finish" : "is-wait"]
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "step__icon",
                  class: { "is-finish": !(index > _vm.activeStep) }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "step__main" }, [
              _c(
                "div",
                {
                  staticClass: "step__title",
                  class: { "is-finish": !(index > _vm.activeStep) }
                },
                [_vm._v(_vm._s(item.name))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "step__description",
                  class: { "is-finish": !(index > _vm.activeStep) }
                },
                [_vm._v(_vm._s(item.description))]
              )
            ])
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }